import React from 'react';
import Checkbox from '4all-ui/components/Checkbox';
import Button from '4all-ui/components/Button';
import { styles } from '4all-ui/styles';
import { compose } from 'redux';
import * as style from './style';
import { SendIcon } from '../../../components/Icons';
import withProducts from '../../../containers/Products';
import { PRODUCT_CORE_ACTIONS } from '../../../helpers/constants';
import { isCheckedAllProducts } from '../../../helpers/products';
import { withMenu } from '../../../containers/Menus';

class ProductsGeneralActions extends React.Component {
  openModal = type => {
    const { onClickProductActions } = this.props;

    onClickProductActions(type);
  };

  checkDisabled = type => {
    const { menus, qttyProductsSelected } = this.props;
    if (type === 'delete') {
      return qttyProductsSelected.products + qttyProductsSelected.categories === 0;
    }

    return qttyProductsSelected.products === 0 || menus.length === 0;
  };

  render() {
    const { toggleAllProducts, isSomeProductChecked, categories } = this.props;
    const isCheckedAll = isCheckedAllProducts(categories);

    return (
      <style.RowActions numberOfSelected={isSomeProductChecked}>
        <style.Content>
          <style.ColActionsLeft sm={3}>
            <Checkbox
              name="general-actions-select-all"
              id="general-actions-select-all"
              label={isCheckedAll ? 'Limpar seleção' : 'Selecionar tudo'}
              onChange={toggleAllProducts}
              checked={isCheckedAll}
              mixed={isCheckedAll}
            />
          </style.ColActionsLeft>

          <style.ColActionsRight sm={9}>
            <Button
              id="btn-send-menu"
              disabled={this.checkDisabled(PRODUCT_CORE_ACTIONS.EXPORT)}
              onClick={() => this.openModal(PRODUCT_CORE_ACTIONS.EXPORT)}
              bgColor={styles.colors.INFO_COLOR}
              border={`1px solid ${styles.colors.INFO_COLOR}`}
              customStyles={{
                height: 50,
                paddingLeft: 15,
                paddingRight: 15,
                svg: {
                  marginRight: 15,
                  path: {
                    fill: '#FFFFFF',
                  },
                },
              }}
            >
              <SendIcon />
              Enviar ao Cardápio
            </Button>
            {/* <Button
              id="btn-action-delete"
              disabled={this.checkDisabled(PRODUCT_CORE_ACTIONS.DELETE)}
              onClick={() => this.openModal(PRODUCT_CORE_ACTIONS.DELETE)}
              bgColor={styles.colors.DANGER_COLOR}
              customStyles={{
                height: 50,
                paddingLeft: 15,
                paddingRight: 15,
                svg: {
                  marginRight: 15,
                  path: {
                    fill: WHITE,
                  },
                },
              }}
            >
              <TrashIcon />
              Excluir
            </Button> */}
          </style.ColActionsRight>
        </style.Content>
      </style.RowActions>
    );
  }
}

export default compose(
  withMenu,
  withProducts
)(ProductsGeneralActions);



// WEBPACK FOOTER //
// ./src/screens/Product/ProductsGeneralActions/index.js